import { logError } from '../util/log';

import { getStoryblokClient } from '../util/storyblok';

// ================ Action types ================ //

const FETCH_BANNER_DATA_REQUEST = 'app/YellowBanner/FETCH_BANNER_DATA_REQUEST';
const FETCH_BANNER_DATA_SUCCESS = 'app/YellowBanner/FETCH_BANNER_DATA_SUCCESS';
const FETCH_BANNER_DATA_ERROR = 'app/YellowBanner/FETCH_BANNER_DATA_ERROR';

// ================ Reducer ================ //
const initialState = {
  bannerData: null,
  bannerLoading: false,
  bannerError: null,
};

const reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_BANNER_DATA_REQUEST:
      return { ...state, bannerLoading: true, bannerError: null };

    case FETCH_BANNER_DATA_SUCCESS:
      return { ...state, bannerLoading: false, bannerData: payload };

    case FETCH_BANNER_DATA_ERROR:
      return { ...state, bannerLoading: false, bannerError: payload };

    default:
      return state;
  }
};

export default reducer;

// ================ Action creators ================ //
export const fetchBannerDataRequest = () => ({
  type: FETCH_BANNER_DATA_REQUEST,
});

export const fetchBannerDataSuccess = (data) => ({
  type: FETCH_BANNER_DATA_SUCCESS,
  payload: data,
});

export const fetchBannerDataError = (error) => ({
  type: FETCH_BANNER_DATA_ERROR,
  error: true,
  payload: error,
});

// ================ Thunks ================ //
export const fetchBannerData = () => async (dispatch, getState) => {
  if (getState().yellowBanner?.bannerData) {
    return;
  }

  dispatch(fetchBannerDataRequest());
  try {
    const storyblokApi = getStoryblokClient();

    // Fetch the annual pass banner data
    // Fetch the yellow banner data
    const response = await storyblokApi.get('cdn/datasource_entries', {
      version: process.env.REACT_APP_ENV === 'production' ? 'published' : 'draft',
      datasource: 'yellow-banner-data',
    });

    const bannerData = response.data.datasource_entries.reduce((acc, entry) => {
      acc[entry.name] = entry.value;
      return acc;
    }, {});

    dispatch(fetchBannerDataSuccess(bannerData));
  } catch (error) {
    dispatch(fetchBannerDataError(error));
    logError(error, 'yellow-banner-data-fetch-failed');
  }
};
